import { MAP_HEIGHT_TILES, MAP_WIDTH_TILES, PLAYER_MOVE_SPEED, TILE_SIZE } from "../models/common";

/**
 * Compute the frame-independent movement step in pixels.
 *
 * @param delta - Elapsed time in milliseconds since the last tick.
 * @param sprintMultiplier - Sprint scale factor (1 = normal, >1 = sprinting).
 * @returns Pixels to move this tick.
 */
export function calcMoveStep(delta: number, sprintMultiplier: number = 1): number {
  return PLAYER_MOVE_SPEED * (delta / 50) * sprintMultiplier;
}

/**
 * Clamp a position so the player stays within map bounds.
 */
export function clampToMapBounds(
  x: number,
  y: number,
  scene: any,
): { x: number; y: number } {
  const playerSize = 16;
  const mapWidthPixels =
    scene.mapHandler?.getMapWidthPixels() || MAP_WIDTH_TILES * TILE_SIZE;
  const mapHeightPixels =
    scene.mapHandler?.getMapHeightPixels() || MAP_HEIGHT_TILES * TILE_SIZE;
  return {
    x: Math.max(playerSize, Math.min(mapWidthPixels - playerSize, x)),
    y: Math.max(playerSize, Math.min(mapHeightPixels - playerSize, y)),
  };
}
